<template>
    <div class="panel latest-galleries">
        <div class="panel-body">
            <scroll-area
                ref="scrollbar"
                :showScrollbar="false"
                :dragScrollEnabled="true">
                <ol>
                    <li
                        class="gallery-thumb"
                        v-for="gallery in galleryList.galleries">
                        <router-link
                            :to="getGalleryLocation(gallery)"
                            @click.native="onGalleryClick($event, gallery)">
                            <img :src="gallery.thumbnailMedia.url">
                        </router-link>
                    </li>
                </ol>
            </scroll-area>
        </div>
    </div>
</template>

<script>
    import GalleryUtils from '../../utils/galleries';
    import ScrollArea from '../reusable/scroll-area';

    const { PaginatedGalleryList } = GalleryUtils;


    export default {
        components: {
            ScrollArea,
        },

        data() {
            return {
                galleryList: new PaginatedGalleryList(null, {
                    pageSize: 18,
                }),
            };
        },

        async mounted() {
            await this.galleryList.loadMore();
        },

        methods: {
            onGalleryClick(ev, gallery) {
                const list = this.galleryList.galleries;
                const index = list.findIndex(g => g.id === gallery.id);

                this.$store.dispatch('pushGalleryViewerContext', {
                    initial: list,
                    params: null,
                    index,
                });
            },

            getGalleryLocation(gallery) {
                return {
                    name: 'gallery',
                    params: {
                        galleryId: gallery.id,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .latest-galleries {
        height: 100px;
        overflow: hidden;
    }
    ol {
        list-style: none;
        margin: 0;
        padding: 0;
        white-space: nowrap;
    }
    li {
        display: inline-block;
        width: 100px;
        height: 100px;
        overflow: hidden;
        position: relative;
    }
    a {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    img {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// LatestGalleries.vue?66ff8200